module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAFoAAAA4CAQAAADXnSfYAAAAs0lEQVR42u3UsQ2AIBRFUUInPUygEzABDmAYwM7E/Tf4LmAMr/iFeqUleTcknhCkz4qdLqcLW1sQo1en6FnYmrXkZIdL8m5xeOvm7nN0dXrnKmxVLTna7pJ82DS8dXP3OXpxeucmbDX1J+xO0VnYyu/DroMd2IEd2IEd2IEd2IEd2IEd2IHdp7ArwlYBO7ADO7ADO7ADO7ADO7ADO7ADO7ADO7ADu19jlwTs0g+w216HXbgA596leGrhfDcAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/welfare/diagonal.png
// module id = PwxS
// module chunks = 216